<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
        <el-button type="primary" size="mini" @click="setValid" >{{$t('getapi[12817]')}}</el-button><!--设为失效-->
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ISSProcessQuotationViewInfo_d"
                :filter_language="['isFirstVenderName','isValidName']"
                :filter_thousandth="['Unit_Price','Net_unit_price','Shipment_Cycle']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_CODE" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_NAME" :label="$t('getapi[116]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_code" :label="$t('getapi[1287]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_Part_Code" :label="$t('getapi[6710]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="RoutingStartName" :label="$t('getapi[6699]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Unit_Price" :label="$t('getapi[6711]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Net_unit_price" :label="$t('getapi[6712]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1344]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Currency_Code" :label="$t('getapi[1227]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Process_Remark" :label="$t('getapi[6702]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Shipment_Cycle" :label="$t('getapi[1295]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Packaging_Style" :label="$t('getapi[6713]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="isFirstVenderName" :label="$t('getapi[6714]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="PriceEffective_Date" :label="$t('getapi[6701]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="isValidName" :label="$t('getapi[6715]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ReviewMan" :label="$t('getapi[550]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ReviewDate" :label="$t('getapi[732]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Remarks" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="CreatePerson" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="CreateDate" :label="$t('getapi[135]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="UpdatePerson" :label="$t('getapi[2591]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="UpdateDate" :label="$t('getapi[1210]')"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ISSProcessQuotationViewInfo_d" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6558]')" queryData="ISSProcessQuotationViewInfo_d" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'dsxwxprice',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('dsxwxprice'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                btn:{
                    endIssue: false
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ISSProcessQuotationViewInfo_d', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6558]"),this.$t("getapi[13]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 128, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 128, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    default:
                        break;
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this
                that.btn.endIssue = false
                if(that.selectData.length > 0){
                    that.btn.endIssue = true
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('dsxwxprice',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ISSProcessQuotationViewInfo_d');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/ISS/PQ/IPQSDList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/PQ/IPQSDExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    that.loading = false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ISSProcessQuotationViewInfo_d",
                    fromname: that.$t('getapi[6558]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = val;
                that.btnauthority()
            },
            //设为无效
            setValid(){
                let that = this;
                let parm={
                Code:'',
                    LangType:that.$processdata.getLang()
                };
                for(let i=0;i<that.selectData.length;i++){
                parm.Code+=that.selectData[i].num+',';
                }
                parm.Code =  parm.Code.substring(0, parm.Code.length - 1);
                that.$http.urlpost('/ISS/PQ/UnISSPQD', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[674]'));//'设置成功！'
                that.getView();
                } 
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
